// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1_WUf","content":"LoadingAlert_content__3d3Ad"};